import { Button, Paper } from "@material-ui/core"
import { Blog as BlogType } from "api"
import NextImage from "common/bit/NextImage"
import NextLink from "common/bit/NextLink"
import TruncateText from "common/bit/TruncateText"
import { fromISOToDateString } from "common/getFormattedDate"
import styled from "styled-components"
import { StyledCol, StyledSvgIcon, TypographyCenter } from "theme/shared"

const StyledImage = styled(NextImage)`
  transition: 1s;
  :hover,
  :focus {
    transform: scale(1.2);
  }
`

const StyledPaper = styled(Paper)<{ $inView: boolean }>`
  box-shadow: ${(p) => p.theme.boxShadows.cardShadow};
  height: 100%;
  width: 100%;
  padding: 0px;
  display: flex;
  flex-direction: column;
  max-width: 480px;
  ${(p) => p.theme.breakpoints.up("md")} {
    height: auto;
    align-self: stretch;
    ${(p) => p.theme.breakpoints.up("md")} {
      height: auto;
      &:nth-child(4) {
        transform: ${({ $inView }) =>
          !$inView ? "translateX(-10%)" : "translateX(0)"};
        opacity: ${({ $inView }) => ($inView ? "1" : "0")};
      }
      &:nth-child(3) {
        transform: ${({ $inView }) =>
          !$inView ? "translateX(-110%)" : "translateX(0)"};
        opacity: ${({ $inView }) => ($inView ? "1" : "0")};
      }
      &:nth-child(2) {
        transform: ${({ $inView }) =>
          !$inView ? "translateX(-210%)" : "translateX(0)"};
        opacity: ${({ $inView }) => ($inView ? "1" : "0")};
      }
      &:nth-child(1) {
        transform: ${({ $inView }) =>
          !$inView ? "translateX(-310%)" : "translateX(0)"};
        opacity: ${({ $inView }) => ($inView ? "1" : "0")};
      }

      transition: all 0.9s 0.9s cubic-bezier(0.19, 0.88, 0.53, 1.12);
      transition-delay: 0.3s;
  }
`

const StyledImageContainer = styled.div`
  aspect-ratio: 320/261;
  width: 100%;
`
const StyledTextWrapper = styled(StyledCol)`
  padding: 10px 18px 18px;
  flex-grow: 1;
`
const StyledDateText = styled(TypographyCenter).attrs({ variant: "body1" })`
  font-size: 14px;
  color: ${(p) => p.theme.colors.onyx};
`

const StyledTruncateTextWrapper = styled.div`
  margin-top: 0px;
  margin-bottom: 10px;
  overflow: hidden;
`
const StyledTruncateText = styled(TruncateText)`
  font-weight: 300;
  font-size: 18px;
  color: ${(p) => p.theme.colors.black};
  line-height: 150%;
  text-align: center !important;
`
const StyledIconWrapper = styled.div`
  width: 24px;
  height: 24px;
`
const StyledBox = styled.div`
  display: flex;
  justify-content: space-between;
  align-items: center;
  margin-top: auto;
  width: 100%;
`
type BlogCardProps = {
  blogDate: BlogType
  inView: boolean
}

const BlogCard = ({ blogDate, inView }: BlogCardProps) => {
  return (
    <NextLink href={blogDate?.link} openInNewTab>
      <StyledPaper $inView={inView}>
        <StyledImageContainer>
          <StyledImage image={blogDate?.image} />
        </StyledImageContainer>
        <StyledTextWrapper $fullWidth $gap="10px">
          <TypographyCenter variant="h3">{blogDate?.name}</TypographyCenter>
          <StyledDateText>{fromISOToDateString(blogDate?.date)}</StyledDateText>
          <StyledTruncateTextWrapper>
            <StyledTruncateText
              line={2}
              element="span"
              truncateText="…"
              text={blogDate?.description}
            />
          </StyledTruncateTextWrapper>

          <StyledBox>
            <StyledIconWrapper />
            <Button variant="contained">לקריאה</Button>
            <StyledIconWrapper>
              <StyledSvgIcon
                src="/icons/exit-site.svg"
                alt="מעבר לאתר חיצוני"
                w={24}
                h={24}
              />
            </StyledIconWrapper>
          </StyledBox>
        </StyledTextWrapper>
      </StyledPaper>
    </NextLink>
  )
}

export default BlogCard
